import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, toRefs } from "vue";
import {
  criterions,
  getItemsBy,
  alternatives,
  getWeightedAcceptability,
  getRangeColorClass,
  stakeholders,
} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableChartTwo',
  props: {
  selectedType: {
    type: String as PropType<"stakeholder" | "criterion">,
  },
},
  setup(__props) {

const props = __props


const { selectedType } = toRefs(props);
const rows = computed(() => {
  if (selectedType.value === "criterion") {
    return criterions.value.map(({ name, id: criterionId }) => {
      const items = getItemsBy({
        criterion: criterionId,
      });

      const alternativesAcceptability = getWeightedAcceptability([...items]);

      const columns = Object.entries(alternativesAcceptability).map(
        ([key, value]) => {
          return { alternativeId: key, acceptability: value };
        }
      );

      return { name, id: criterionId, columns };
    });
  }
  if (selectedType.value === "stakeholder") {
    return stakeholders.value.map(({ name, id: stakeholderId }) => {
      const items = getItemsBy({
        stakeholder: stakeholderId,
      });

      const alternativesAcceptability = getWeightedAcceptability([...items]);

      const columns = Object.entries(alternativesAcceptability).map(
        ([key, value]) => {
          return { alternativeId: key, acceptability: value };
        }
      );

      return { name, id: stakeholderId, columns };
    });
  }
  return [];
});

return { __sfc: true,props, selectedType, rows, alternatives, getRangeColorClass }
}

})